jQuery(document).ready(function($) {

	/* Hamburger Menu: Mobile */ 
	$('.hamburger-menu').click(function(){
        $(this).toggleClass('open');
        if($(this).hasClass('open')){ 
            $('.main-nav').height($(window).height());
        } else {
            $('.main-nav').height(0);
        }
    });
    
    $(".animsition").animsition({
        inClass: 'ns-overlay-slide-in-top',
        outClass: 'ns-overlay-slide-out-bottom',
        inDuration: 2200,
        outDuration: 2200,
        linkElement: 'a:not([target="_blank"]):not([href^="#"])',
        onLoadEvent: true,
        loading: false,
        browser: [ 'animation-duration', '-webkit-animation-duration'],
        overlay : false,
        overlayClass : 'animsition-overlay-slide',
        overlayParentElement : 'body',
        transition: function(url){ window.location.href = url; }
    });

    $('a:not([target="_blank"]):not([href^="#"])').on('click', function() {
        if(window.innerWidth >= 1024){
            $('header').css('transform', 'translateX(-220px)');
        }
    });

    if(!$('body').hasClass('home')) {
        setTimeout(function(){
            if (window.innerWidth >= 1024) {
                $('header').css('transform', 'translateX(0)');
            }
        }, 600);
        
        anime({
            targets: '.background-svgs path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1600,
            delay: 1000
        });
    }

    if($('body').hasClass('home')){

        // Let's start working on this homepage text
        var heroText = $('.page-header h1').text();
        var textArray = [];

        for(var x = 0; x < heroText.length; x++) {
            textArray.push("<span>"+heroText[x]+"</span>");
        }

        $('.page-header h1').html(textArray.join(''));

        var headerOffset = $('.page-header h1').offset().top;
        $('.page-header h1 span').each(function(){
            if($(this).offset().top > headerOffset){
                $(this).addClass('break');
                headerOffset = $(this).offset().top;
            }
        });

        textArray = [];
        var heroStrings = "<span class='inline-block'>";
        $('.page-header h1 span').each(function(){
            if(!$(this).hasClass('break')) {
                heroStrings += $(this).text();
            } else {
                heroStrings += "</span>";
                textArray.push(heroStrings);
                heroStrings = "<span class='inline-block'>";
                heroStrings += $(this).text();
            }
        });
        heroStrings += "</span>";
        textArray.push(heroStrings);

        $('.page-header h1').html(textArray.join(''));

        // Add listener for video on homepage
        $('video').on('ended', function(){
            $('.loading-screen').css('opacity', 0);
            $('.home').css('overflow', 'auto');
            setTimeout(function(){
                $('.loading-screen').css('visibility', 'hidden');
            },500);
            
            $('header').css('transform', 'translateX(0)');
            anime({
                targets: '.page-header h1 span:nth-child(1)',
                translateX: [100, 0],
                opacity: [0, 1],
                duration: 1200,
                easing: 'linear',
            });
            anime({
                targets: '.page-header h1 span:nth-child(even)',
                translateX: [150, 0],
                opacity: [0, 1],
                delay: 1200,
                duration: 1200,
                easing: 'linear',
            });
            anime({
                targets: '.page-header h1 span:nth-child(odd)',
                translateX: [-150, 0],
                opacity: [0, 1],
                delay: anime.stagger(2400),
                duration: 1200,
                easing: 'linear',
                complete: function(anim) {
                    var finalString = '';
                    $('.page-header h1 span').each(function(){
                        finalString += $(this).text();
                    });                        
                    $('.page-header h1').html(finalString);
                }
            });

            anime({
                targets: '.background-svgs path',
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'easeInOutSine',
                duration: 3600,
                delay: 0
            });
        });
    }

    setTimeout(function() {
        $('.page-header h1').css({
            transform: 'translatex(0)',
            opacity: 1
        });
    }, 900);

    $('.slideshow-container').slick({
        arrows: false,
        dots: false,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 600,
        fade: true,
        cssEase: 'linear'
    });

    // setTimeout(function(){ 
    //     $('.logoslider').slick({
    //         arrows: false,
    //         infinite: true,
    //         cssEase: 'linear',
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 2000,
    //         autoplay: true,
    //         autoplaySpeed: 0,
    //         variableWidth: true,
    //         responsive: [
    //             {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 speed: 2000,
    //                 centerMode: true,
    //                 centerPadding: '80px',
    //             }
    //             },
    //         ]
    //     });
    // }, 1000);

    $('.infiniteslide').infiniteslide({
        'speed': 200, //speed this is px/min
        'direction': 'left', //choose  up/down/left/right
        'pauseonhover': false, //if true,stop onmouseover
        'responsive': true, //width/height recalculation on window resize. child element's width/height define %/vw/vh,this set true.
        'clone': 1 //if child elements are too few (elements can't "infinite"), set 2 or over.
    });



    /**
     * Map Styles
     * 
     */

    var styles = [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e9e9e9"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dedede"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#333333"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f2f2f2"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        }
    ];

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            styles      : styles
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var icon = {
            url: "/wp-content/themes/qwest-contracting-theme/img/icon_mapPin-01.png", // url
            scaledSize: new google.maps.Size(32, 46), // scaled size
        };

        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            icon: icon
        });

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){

            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    // Render maps on page load.
    $('.acf-map').each(function () {
        initMap($(this));
    });

    $(window).scroll(function () {
       var parallaxAmt = -0.15;
       var currentScroll = $(document).scrollTop();
       $('.background-svgs').css({
           transform: "translateY("+ (parallaxAmt * currentScroll) +"px)"
       })
    });

    if($('body').hasClass('blog') || $('body').hasClass('archive')){
        $(function() {

            var $el, leftPos,
                $mainNav = $("#menu-categories");
            
            $mainNav.append("<li id='magic-line'></li>");
            var $magicLine = $("#magic-line");
            if($('body').hasClass('blog')){
                $magicLine
                    .css("left", $(".current-menu-item a").position().left - 30)
                    .data("origLeft", $magicLine.position().left)
            } else {
                $magicLine
                    .css("left", $(".current-menu-item a").position().left)
                    .data("origLeft", $magicLine.position().left)
            }
            $("#menu-categories li a").hover(function() {
                $el = $(this);
                leftPos = $el.position().left;
                $magicLine.stop().animate({
                    left: leftPos,
                });
            }, function() {
                $magicLine.stop().animate({
                    left: $magicLine.data("origLeft"),
                });    
            });
        });
    }
});

